// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { productCompareFlyOutStyles } from "@rpsc/Overrides/Components/ProductCompareFlyOut";
import { color, layoutContainer, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.headerTitleText = {
    variant: "h5",
    color: "common.black",
    css: css`
        margin-bottom: 0;
    `,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    ...productCompareFlyOutStyles.carouselDrawerContainer,
    css: css`
        ${layoutContainer}
        &&&&& {
            .swiper-initialized {
                margin-left: 46px;
                width: calc(100% - 95px);
            }
        }
        .swiper-slide {
            > div {
                height: 100%;
            }
            > div > div {
                height: 100%;
            }
        }
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
productCompareFlyOutStyles.headerGridContainer = {
    css: css`
        padding-top: 16px;
        ${layoutContainer}
    `,
};

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        drawerBody: css`
            background: ${getColor("common.background")};
        `,
        drawerContent: css`
            overflow: hidden;
            padding-bottom: 16px;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.headerActionsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
        gap: 12px;
    `,
};
productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "tertiary",
    sizeVariant: "small",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
productCompareFlyOutStyles.headerCompareButton = {
    variant: "primary",
    sizeVariant: "small",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
productCompareFlyOutStyles.productMiniCardStyles = {
    productGridContainerStyles: {
        container: {
            css: css`
                border: none;
                padding-top: 10px;

                .pricing-info-container {
                    min-height: 45px;
                    justify-content: flex-end;
                    margin-bottom: 0;
                    padding-bottom: 16px;
                }
            `,
        },
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 72px;
                height: 72px;
            `,
        },
    },
    productPartNumbersStyles: {
        manufacturerItemLabelText: {
            css: css`
                white-space: nowrap;
            `,
        },
        erpNumberLabelText: {
            css: css`
                white-space: nowrap;
            `,
        },
    },
    productPriceAndActionsTopSectionStyles: {
        productPriceStyles: {
            wrapper: {
                css: css`
                    margin-bottom: 0;
                `,
            },
        },
        productGridContainer: {
            price: {
                css: css`
                    margin-bottom: 0;
                `,
            },
        },
    },
};

productCompareFlyOutStyles.cardWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        padding: 10px 0 10px 16px;
        &:hover ${IconWrapper}, &:hover svg {
            color: ${color("common.ui8")};
        }
    `,
};
